<div class="wrapper-container">
    <div class="wrapper-button pt-5 ml-4" *ngIf="isBackButtonVisible">
        <i
          class="pi pi-arrow-left cursor-pointer"
          (click)="goBack()"
        ><span class="wrapper-button-text">| Return to previous page</span></i>
    </div>
    <div class="wrapper-button pt-5 ml-4" *ngIf="relativeBackButton">
      <i
        class="pi pi-arrow-left cursor-pointer"
        (click)="goBack()"
      ><span class="wrapper-button-text">| Return to previous page</span></i>
    </div>
    <ng-content></ng-content>
</div>
